import React from "react"
import { Box, Flex, Grid, Container } from "theme-ui"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from "@emotion/styled"
import { useResponsiveValue } from "@theme-ui/match-media"
import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
} from "react-accessible-accordion"
import moment from "moment"
import "assets/css/accordion.css"
import NewsletterCard from "components/cards/newsletter-card"
const FullWidth = styled.div`
    background: ${(props) => props.theme.colors.light_blue_1};
    margin-left: calc(50% - 50vw) !important;
    margin-right: calc(50% - 50vw) !important;
`

const PageWrapper = styled.div`
    position: relative;
    color: #ffffff;
    & .caption-box-topbanner {
        text-shadow: #545454 1px 0 10px;
    }

    & h2 {
        text-align: center !important;
    }

    & .accordion-box {
        width: 100%;
    }

    & .show-md {
        display: none;
    }
    & .hide-md {
        display: block;
    }

    & .accordion__button {
        font-weight: 700;
        color: ${(props) => props.theme.colors.primary};
        border-color: ${(props) => props.theme.colors.primary};
        border-radius: 1rem;
        padding: 0.75rem;
        &:hover {
            border-color: #4765ac;
        }
    }
    & .accordion__item {
        border-color: transparent;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        & .show-md {
            display: block;
        }
        & .hide-md {
            display: none;
        }
        & .grid-content {
            grid-template-columns: 1fr;
        }
    }
`

const getArchiveNewsletter = (data, subYear) => {
    let date = new Date()
    date.setFullYear(date.getFullYear() - subYear)
    const year = date.getFullYear()

    const newsletter = data.filter((newsletter) => {
        const issueDate =
            newsletter.node.Content[0].Newsletter_Info.date.split("-")
        return +issueDate[0] === year
    })
    return { newsletter, year }
}

// markup
const IndexPage = ({ data }) => {
    let newsletters = data.edges.sort(function (a, b) {
        const date1 = a.node.Content[0].Newsletter_Info.date
        const date2 = b.node.Content[0].Newsletter_Info.date
        return Date.parse(date2) - Date.parse(date1)
    })
    console.clear()

    let thisYear = getArchiveNewsletter(newsletters, 0)

    const archives = []
    for (let i = 1; i <= 3; i++) {
        const archive = getArchiveNewsletter(newsletters, i)
        archives.push(archive)

        if (!thisYear.newsletter[0]) {
            thisYear = archive
        }
    }

    const thisMonth = thisYear.newsletter[0]

    let mainImg,
        mainTitle,
        mainDesc = null
    if (thisMonth) {
        mainImg = getImage(thisMonth.node.image)
        mainTitle = thisMonth.node.title
        mainDesc = thisMonth.node.description
    }
    const pastMonths = Object.entries(thisYear.newsletter).slice(1, 12)

    const imageWidth = useResponsiveValue([100, 150, 190, 190, 250, 350])
    return (
        <PageWrapper>
            <Grid
                gap={2}
                columns={[2, "2fr 3fr"]}
                className="grid-content"
                sx={{ marginBottom: "2rem" }}
            >
                <Box>
                    <GatsbyImage
                        image={mainImg}
                        alt={mainTitle}
                        className="hide-md"
                    />
                </Box>
                <Box sx={{ px: "1rem" }}>
                    <h2>{mainTitle}</h2>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: mainDesc,
                        }}
                    ></div>
                </Box>
                <Box>
                    <GatsbyImage
                        image={mainImg}
                        alt={mainTitle}
                        className="show-md"
                        width={imageWidth}
                    />
                </Box>
            </Grid>
            <FullWidth>
                <Container sx={{ pt: "1rem" }}>
                    <h2>{moment().subtract(1, 'year').format("YYYY")} Newsletters</h2>
                    <Flex
                        sx={{
                            flexWrap: "wrap",
                        }}
                    >
                        {pastMonths.map((data, index) => {
                            const { issue, date, url } =
                                data[1].node.Content[0].Newsletter_Info
                            const title = data[1].node.title

                            return (
                                <NewsletterCard
                                    key={index}
                                    url={url}
                                    issue={issue}
                                    date={date}
                                    title={title}
                                />
                            )
                        })}
                    </Flex>
                </Container>
            </FullWidth>

            <Flex sx={{ flexDirection: "column" }}>
                <Box>
                    <h2>Archives</h2>
                </Box>

                <Box className="accordion-box">
                    <Accordion allowZeroExpanded>
                        {archives.map((archive, index) => {
                            const lists = archive.newsletter.map(
                                (nodes, idx) => {
                                    const { url, issue, date } =
                                        nodes.node.Content[0].Newsletter_Info
                                    return (
                                        <NewsletterCard
                                            key={idx}
                                            issue={issue}
                                            date={date}
                                            url={url}
                                            title={nodes.node.title}
                                        />
                                    )
                                }
                            )
                            return (
                                <AccordionItem key={index}>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            {archive.year}
                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        {lists}
                                    </AccordionItemPanel>
                                </AccordionItem>
                            )
                        })}
                    </Accordion>
                </Box>
            </Flex>
        </PageWrapper>
    )
}

export default IndexPage
